import { manifest } from '@/data';
import { SectionEyebrow } from '@/components/ui/SectionEyebrow';

export function AboutPage() {
  return (
    <div className="relative mx-auto max-w-3xl px-6 pt-28 pb-20">
      <SectionEyebrow start>· About ·</SectionEyebrow>
      <h1 className="display-title is-start mb-6">
        About <em>Ars Magica</em>
      </h1>
      <p className="mb-4 text-[15px] leading-relaxed text-parchment-100/75">
        Ars Magica is an independent, free character creator for{' '}
        <em className="text-gold-300">Ars Magica — Definitive Edition</em>. Everything runs in
        your browser: no account, no server, no tracking. Characters live in your local storage
        and can be shared via URL or exported to JSON.
      </p>

      <h2 className="mt-10 font-display text-[13px] uppercase tracking-[0.32em] text-gold-400">
        Licensing
      </h2>
      <div
        className="mt-2 mb-5 h-px w-full"
        style={{ background: 'linear-gradient(to right, #6a4d18, transparent)' }}
      />
      <p className="mb-3 text-[15px] leading-relaxed text-parchment-100/75">
        The rules mechanics used by this tool fall under the ArM5 Open License. The Definitive
        Edition manuscript and all associated trademarks are © Atlas Games. This tool ships
        mechanics only — names, costs, types, and numeric parameters — along with short,
        paraphrased summaries. No verbatim prose from the manuscript is embedded; instead,
        entries link back to the source.
      </p>
      <p className="text-[15px] leading-relaxed text-parchment-100/75">
        Not affiliated with, endorsed by, or sponsored by Atlas Games.
      </p>

      <h2 className="mt-10 font-display text-[13px] uppercase tracking-[0.32em] text-gold-400">
        Dataset
      </h2>
      <div
        className="mt-2 mb-5 h-px w-full"
        style={{ background: 'linear-gradient(to right, #6a4d18, transparent)' }}
      />
      <p className="mb-3 text-[13px] text-parchment-100/60">
        Generated {new Date(manifest.generatedAt).toLocaleString()} from the public manuscript
        mirror.
      </p>
      <ul className="ml-5 list-disc text-[14px] text-parchment-100/70 space-y-1">
        <li>{manifest.counts.virtues} virtues</li>
        <li>{manifest.counts.flaws} flaws</li>
        <li>{manifest.counts.abilities} abilities</li>
        <li>{manifest.counts.arts} hermetic arts</li>
        <li>{manifest.counts.houses} houses</li>
        <li>{manifest.counts.spells} spells</li>
      </ul>

      <h2 className="mt-10 font-display text-[13px] uppercase tracking-[0.32em] text-gold-400">
        Data source
      </h2>
      <div
        className="mt-2 mb-5 h-px w-full"
        style={{ background: 'linear-gradient(to right, #6a4d18, transparent)' }}
      />
      <p className="text-[15px] leading-relaxed text-parchment-100/75">
        Reference data is sourced from the{' '}
        <a
          className="text-gold-300 underline-offset-4 hover:underline"
          href="https://publish.obsidian.md/ars-magica-definitive-manuscript/Homepage"
          target="_blank"
          rel="noreferrer noopener"
        >
          Ars Magica Definitive Manuscript Copy
        </a>
        , a fan transcription of an early-backer manuscript. Donations to the transcriber:{' '}
        <a
          className="text-gold-300 underline-offset-4 hover:underline"
          href="https://ko-fi.com/vansilke"
          target="_blank"
          rel="noreferrer noopener"
        >
          ko-fi.com/vansilke
        </a>
        .
      </p>
    </div>
  );
}
